import InquiryFormModal from './InquiryFormModal.jsx'

export default InquiryFormModal
